import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_OUTCOMES } from '../../content/placeholders';
import { ArrowIcon, Eyebrow, WhatsAppIcon, focusRing, whatsappLink } from './shared';

export const HOME_SERVICES = [
  { slug: 'social-media', name: 'Social media', ask: 'social media' },
  { slug: 'branding', name: 'Branding', ask: 'branding' },
  { slug: 'design', name: 'Design & creatives', ask: 'design and creatives' },
  { slug: 'web-development', name: 'Websites', ask: 'a website' },
  { slug: 'marketing', name: 'Marketing & ads', ask: 'marketing and ads' },
];

const NUMBER_COLORS = ['text-apn-orange', 'text-apn-pink', 'text-apn-indigo', 'text-apn-saffron', 'text-apn-orange'];

export default function ServicesPricing() {
  return (
    <section aria-labelledby="home-services-title" className="overflow-x-clip bg-apn-surface-2 py-14 sm:py-20 short:py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-4 lg:grid-cols-[1fr_1.1fr] lg:items-end">
          <div>
            <Eyebrow>What we do</Eyebrow>
            <h2 id="home-services-title" data-animate="split-heading" className="mt-3 font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.03em] text-apn-ink sm:text-5xl lg:text-6xl">
              Pick what you need.
            </h2>
          </div>
          <p className="text-lg text-apn-text lg:pb-2">
            Not sure which one? Message us on WhatsApp and we’ll tell you exactly what fits your brand.
          </p>
        </div>

        <ul data-animate="stagger" className="mt-10 divide-y divide-apn-line border-y border-apn-line">
          {HOME_SERVICES.map((svc, i) => {
            const outcome = SERVICE_OUTCOMES[svc.slug];
            return (
              <li key={svc.slug} className="grid grid-cols-[2.5rem_1fr] gap-x-3 gap-y-4 py-6 sm:py-7 lg:grid-cols-[4rem_1fr_auto] lg:items-center lg:gap-6">
                <span aria-hidden="true" className={`pt-1 font-display text-xl font-extrabold lg:pt-0 lg:text-3xl ${NUMBER_COLORS[i]}`}>
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="font-display text-2xl font-extrabold tracking-[-0.02em] text-apn-ink sm:text-3xl">{svc.name}</h3>
                  <p className="mt-1 text-base text-apn-text sm:text-lg">{outcome}</p>
                </div>
                <div className="col-start-2 flex flex-wrap items-center gap-2 lg:col-start-auto">
                  <a
                    href={whatsappLink(`Hi Apnaaapan, I want help with ${svc.ask} for my brand.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-cta={`home-service-whatsapp-${svc.slug}`}
                    className={`inline-flex min-h-[48px] items-center gap-2 rounded-full bg-apn-ink px-5 font-semibold text-apn-bg transition hover:bg-apn-orange hover:text-white ${focusRing}`}
                    aria-label={`Ask about ${svc.name} on WhatsApp`}
                  >
                    <WhatsAppIcon className="h-5 w-5" />
                    Ask on WhatsApp
                  </a>
                  <Link
                    to={`/services/${svc.slug}`}
                    data-cta={`home-service-details-${svc.slug}`}
                    aria-label={`What's included in ${svc.name}`}
                    className={`inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-apn-ink text-apn-ink transition hover:border-apn-orange hover:text-apn-orange ${focusRing}`}
                  >
                    <ArrowIcon />
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
